var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 28.0003L15.9997 2.66699L30.6663 28.0003H1.33301ZM5.93301 25.3337H26.0663L15.9997 8.00033L5.93301 25.3337ZM15.9997 24.0003C16.3775 24.0003 16.6941 23.8725 16.9497 23.617C17.2052 23.3614 17.333 23.0448 17.333 22.667C17.333 22.2892 17.2052 21.9725 16.9497 21.717C16.6941 21.4614 16.3775 21.3337 15.9997 21.3337C15.6219 21.3337 15.3052 21.4614 15.0497 21.717C14.7941 21.9725 14.6663 22.2892 14.6663 22.667C14.6663 23.0448 14.7941 23.3614 15.0497 23.617C15.3052 23.8725 15.6219 24.0003 15.9997 24.0003ZM14.6663 20.0003H17.333V13.3337H14.6663V20.0003Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.f4dafef22d4cd99c995b3edbbbe850ea.svg";
export { ForwardRef as ReactComponent };